import { useLocation, Navigate, Outlet } from "react-router-dom";
import { getAuthToken } from "../../Localstorage/Localstorage"; 

const PrivateAuth = () => {
    const location = useLocation();
    const token = getAuthToken(); 

    return (
        token != null
            ? <Outlet state={{ from: location }} />
            : <Navigate to="/" state={{ from: location.pathname }} replace />
    );
};

export default PrivateAuth;
